<div class="dimensions tool-box">
    <h5 class="title">
        {{ 'mimic-drawing.dimensions' | translate }}
    </h5>
    <div class="input-container none-padding-bottom">
        <app-editor-input-text
            [name]="DIMENSION_W"
            label="w"
            [value]="width"
            [type]="width == MIXED_STRING ? 'text' : 'number'"
            [shouldEmitOnBlur]="true"
            (onInputChange)="handleDimensionChange($event)"
            [minValue]="0"
            (onInputKeyDown)="validDimensionKeyDown($event)">
        </app-editor-input-text>
        <app-editor-input-text
            [name]="DIMENSION_H"
            label="h"
            [value]="height"
            [type]="height == MIXED_STRING ? 'text' : 'number'"
            [shouldEmitOnBlur]="true"
            (onInputChange)="handleDimensionChange($event)"
            [minValue]="0"
            (onInputKeyDown)="validDimensionKeyDown($event)">
        </app-editor-input-text>
        <ng-container *ngIf="displayThickness">
            <app-editor-input-text
                [name]="DIMENSION_H"
                label="t"
                [value]="thickness"
                [type]="'number'"
                [shouldEmitOnBlur]="true"
                (onInputChange)="handleThicknessChange($event)"
                [minValue]="0"
                (onInputKeyDown)="validDimensionKeyDown($event)">
            </app-editor-input-text>
        </ng-container>
    </div>
    <div class="constrain-container" (click)="constrainClick()" [class.disabled]="isConstrainDisabled">
        <mat-icon *ngIf="constrainState" svgIcon="proportions-selected"></mat-icon>
        <mat-icon *ngIf="!constrainState" svgIcon="proportions-unselected"></mat-icon>
        <span class="constrain-text">{{ 'mimic-drawing.constrain-proportions' | translate }}</span>
    </div>
</div>
